export default "__VITE_ASSET__DNfP3lem__"